import {
  Box,
  Text,
  Input,
  Button,
  Flex,
} from "@chakra-ui/react";
import {
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar";
import { useSurvey } from "./BusinessSurveyContext";

export default function BusinessSurveyOne() {
  const navigate = useNavigate();
  const { surveyData, updateSurveyData } = useSurvey();
  const { name, email, businessName } = surveyData || {};

  return (
    <Box minHeight="100vh" display="flex" flexDirection="column" bg="white">
      <Navbar />
      {/* Header */}
      <Box
        bg="#00C49A"
        height="80px"
        display="flex"
        alignItems="flex-end"
        justifyContent="center"
        pb={2}
      >
        <Text fontSize="lg" fontWeight="bold" color="black">
          RESOURCES
        </Text>
      </Box>

      {/* Main Content */}
      <Box
        flex="1"
        overflowY={["auto", "auto", "visible"]}
        px={4}
        pt={6}
        pb={["140px", "160px"]}
        display="flex"
        justifyContent="center"
        minHeight={{ base: "auto", md: "calc(100vh - 200px)" }}
      >
        <Box width="100%" maxW="420px">
          {/* Back Arrow */}

          {/* Title */}
          <Text fontWeight="bold" fontSize="xl" mb={1} textAlign={"center"}>
            Pilot Small Business Assistance Application Survey
          </Text>


          {/* Progress Bar (bigger) */}
          <Box
            width="100%"
            maxW={{ base: "360px", md: "440px" }}
            mx="auto"
            mb={10}
            height="32px"
            border="2px solid black"
            borderRadius="full"
            overflow="hidden"
          >
            <Box
              width="16%"
              height="100%"
              bg="#00C49A"
              borderRightRadius="full"
            />
          </Box>

          {/* Form Fields */}
          <Box mb={12}>
            <Box mb={8}>
              <Text fontWeight="bold" fontSize="md" mb={2}>
                Name
              </Text>
              <Input
                placeholder="Enter text here...."
                variant="filled"
                bg="#E0E0E0"
                value={name || ""}
                onChange={(e) => updateSurveyData({ name: e.target.value })}
                _focus={{
                  boxShadow: "none",
                  bg: "#E0E0E0",
                  borderBottom: "2px solid #00C49A",
                }}
                borderBottom="2px solid #00C49A"
                borderRadius="md"
                fontStyle="italic"
              />
            </Box>

            <Box mb={8}>
              <Text fontWeight="bold" fontSize="md" mb={2}>
                Email Address
              </Text>
              <Input
                placeholder="Enter text here...."
                variant="filled"
                bg="#E0E0E0"
                value={email || ""}
                onChange={(e) => updateSurveyData({ email: e.target.value })}
                _focus={{
                  boxShadow: "none",
                  bg: "#E0E0E0",
                  borderBottom: "2px solid #00C49A",
                }}
                borderBottom="2px solid #00C49A"
                borderRadius="md"
                fontStyle="italic"
              />
            </Box>

            <Box mb={4}>
              <Text fontWeight="bold" fontSize="md" mb={2}>
                Business Name
              </Text>
              <Input
                placeholder="Enter text here...."
                variant="filled"
                bg="#E0E0E0"
                value={businessName || ""}
                onChange={(e) => updateSurveyData({ businessName: e.target.value })}
                _focus={{
                  boxShadow: "none",
                  bg: "#E0E0E0",
                  borderBottom: "2px solid #00C49A",
                }}
                borderBottom="2px solid #00C49A"
                borderRadius="md"
                fontStyle="italic"
              />
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Back/Next Buttons (moved up) */}
      <Box
        position="absolute"
        bottom={["110px", "120px"]} // ⬆️ Moved up
        width="100%"
        bg="white"
        py={3}
        px={6}
        display="flex"
        justifyContent="space-between"
        zIndex={10}
      >
        <Button
          variant="ghost"
          leftIcon={<FaArrowLeft color="#00C49A" />}
          color="black"
          onClick={() => navigate("/small_business_app", {
          })}
        >
          Back
        </Button>
        <Button
          variant="ghost"
          onClick={() =>
            navigate("/business-app-2", {
            })
          }
          rightIcon={<FaArrowRight color="#00C49A" />}
          color="black"
        >
          Next
        </Button>
      </Box>

      {/* Bottom Navigation */}
      <Flex
        position="fixed"
        bottom={0}
        width="100%"
        bg="white"
        py={3}
        justifyContent="space-around"
        borderTop="2px solid black"
        zIndex={5}
      >
      </Flex>
    </Box>
  );
}